import React from 'react';
import Button from './Button';
import Modal from './Modal';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

interface DeleteConfirmModalProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  const { t } = useTranslation();

  const finalTitle = title || t('buttons.delete');
  const finalDescription = description || t('common.deleteConfirmation');
  const finalConfirmLabel = confirmLabel || t('buttons.yes');
  const finalCancelLabel = cancelLabel || t('buttons.cancel');
  return (
    <Modal
      size="xs"
      open={open}
      onClose={onClose}
      title={finalTitle}
      footer={
        <>
          <Button variant="blueFont" sx={{ fontSize: '14px' }} onClick={onClose}>
            {finalCancelLabel}
          </Button>
          <Button
            variant="outlinedRed"
            sx={{ fontSize: '14px' }}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? t('common.deleting') : finalConfirmLabel}
          </Button>
        </>
      }
    >
      <Typography sx={{ mt: 2 }}>{finalDescription}</Typography>
    </Modal>
  );
};

export default DeleteConfirmModal;
